import type { TOC } from '@ember/component/template-only'
import type { PhosphorIconName } from 'phosphor-icons'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Args {
  isDisabled?: boolean
  icon: PhosphorIconName
  label: string
}

interface Signature {
  Element: HTMLButtonElement
  Args: Args
}

export const BooksTableBooksTaskButton: TOC<Signature> = <template>
  <button disabled={{@isDisabled}} type="button" class="leading-none" ...attributes>
    <PhosphorIcon
      class="text-center {{if @isDisabled 'text-dusty-black-100' 'text-dusty-black-250'}}"
      @icon={{@icon}}
    />
    {{#if @label}}
      <div class="text-center {{if @isDisabled 'text-dusty-black-100' 'text-dusty-black-250'}} whitespace-nowrap">
        {{@label}}
      </div>
    {{/if}}
  </button>
</template>
